export const attachEvent = (
    element,
    eventName,
    callback
) => {
    if (element && eventName && element.getAttribute(`listener-${callback.name}`) !== 'true') {
            element.setAttribute(`listener-${callback.name}`, 'true');
            element.addEventListener(eventName, (event) => {
                callback(event);
            });
        }
    };

export const detachEvent = (
    element,
    eventName,
    callback
    ) => {
    if (eventName && element) {
        element.removeEventListener(eventName, callback);
    }
};